<div
  [id]="zipYiElement.GiftCardDenominationSelect"
  class="zip-select-option"
  [ngClass]="[
    !selectOptionV2Service.isValidData ? 'is-error' : '',
    checkoutStateService.isCheckoutBtnTriggered ? 'is-disable' : '',
    hideDenominations ? 'is-hidden' : ''
  ]"
>
  <div class="select-option-wrapper">
    <div class="select-option-label">
      <span>
        {{ titleSelectOption }}
      </span>
    </div>
    <div class="select-option-selected-value">
      <span *ngIf="selectedOption">
        {{ selectedOption !== 'custom' ? '$' + selectedOption : 'Custom' }}
      </span>
      <span *ngIf="!selectedOption"> Select option </span>
    </div>
    <div class="overlay-select" (click)="toggleDropdown($event)"></div>
    <div class="select-option-dropdown" (mouseleave)="closeDropdown($event)">
      <div
        role="option"
        class="option-item"
        *ngFor="let denomonationOption of selectOptionV2Service.denomonationOptions"
        (click)="onSelect($event, denomonationOption)"
        [ngClass]="{
          'is-disable': denomonationOption.stock === 'OUT_OF_STOCK',
          'is-selected': denomonationOption.isSelected
        }"
      >
        {{ denomonationOption.price !== 'custom' ? '$' + denomonationOption.price : 'Custom' }}
        <span *ngIf="denomonationOption.stock === 'OUT_OF_STOCK'"> Back in stock soon! </span>
      </div>
    </div>
  </div>
</div>

<div
  class="zip-row-input"
  *ngIf="selectedOption == 'custom'"
  [ngClass]="{ 'is-error': !selectOptionV2Service.isValidCustomAmount, 'is-valid': isFocused }"
>
  <div class="row-input-wrapper">
    <div class="input-label">
      <span> Custom amount </span>
    </div>
    <div class="input-wrapper">
      <input
        [id]="zipYiElement.GiftCardCustomDenominationInput"
        type="text"
        [(ngModel)]="customAmountValue"
        (focus)="selectOptionV2Service.handleFocusInput($event); handleFocusInputCustomAmount($event)"
        (blur)="selectOptionV2Service.handleBlurInput($event); handleOutFocusInputCustomAmount($event)"
        (input)="handleInputChangeCustomAmount($event)"
        [OnlyNumber]="true"
      />
    </div>
  </div>
  <div class="row-input-notice">
    <span [ngClass]="{ 'is-error': !selectOptionV2Service.isValidCustomAmount }" data-testid="denomination-notice">
      Amount must be between ${{ minCustomPrice }} and ${{ maxCustomPrice }}
    </span>
  </div>
</div>

<div class="zip-select-option-error is-error" *ngIf="!selectOptionV2Service.isValidData">
  Please enter amount of gift card!
</div>
